import utils from "../utils";

var cursor = {
	mousepos: {
		x: 0,
		y: 0,
	},
	//TODO ridurre codice con variabili
	DOM: {
		el: document.getElementById("cursor"),
		circle: document.querySelector("#cursor circle"),
		arrow: document.querySelector("#cursor .arrow"),
		links: document.querySelectorAll("a, button, .smx-onclick, .over-link"),
		originalColor: window.getComputedStyle(document.querySelector('#cursor circle')).fill,
	},
	bounds: document.getElementById("cursor").getBoundingClientRect(),
	state: {
		arrowCursor: false,
		notAllowed: false,
	},
	disable: function () {
		if (!cursor.state.notAllowed) {
			document.body.style.cursor = "not-allowed";
			cursor.state.notAllowed = true;
		}
	},
	enable: function () {
		if (cursor.state.notAllowed) {
			document.body.style.cursor = "";
			cursor.state.notAllowed = false;
		}
	},
	lerp: function (a, b, n) {
		return (1 - n) * a + n * b;
	},
	renderedStyles: {
		tx: {
			previous: 0,
			current: 0,
			amt: 0.2,
		},
		ty: {
			previous: 0,
			current: 0,
			amt: 0.2,
		},
		scale: {
			previous: 0.5,
			current: 0.5,
			amt: 0.2,
		},
		opacity: {
			previous: 1,
			current: 1,
			amt: 0.2,
		},
	},
	onMouseMoveEv: function () {
		cursor.renderedStyles.tx.previous = cursor.renderedStyles.tx.current =
			cursor.mousepos.x - cursor.bounds.width;
		cursor.renderedStyles.ty.previous = cursor.renderedStyles.ty.previous =
			cursor.mousepos.y - cursor.bounds.height;
		requestAnimationFrame(function () {
			cursor.render();
		});
		window.removeEventListener("mousemove", cursor.onMouseMoveEv);
	},
	enter: function (type) {

		cursor.renderedStyles["scale"].current = 1.3;
		if (type == "arrow") {
			if (!cursor.state.arrowCursor) {
				cursor.DOM.arrow.style.opacity = "1";
				cursor.DOM.circle.style.fill = "white";
				cursor.state.arrowCursor = true;
			}
		} else {
			cursor.renderedStyles["opacity"].current = 0.3;
		}
	},
	leave: function (type) {
		cursor.renderedStyles["scale"].current = 0.5;
		if (type == "arrow") {
			if (cursor.state.arrowCursor) {
				cursor.DOM.arrow.style.transition = "opacity 0.2s";
				cursor.DOM.circle.style.fill = cursor.DOM.originalColor;
				cursor.DOM.arrow.style.opacity = "0";
				setTimeout(function () {
					cursor.DOM.el.style.transition = "";
				}, 20);
				cursor.state.arrowCursor = false;
			}
		} else {
			cursor.renderedStyles["opacity"].current = 1;
		}
	},
	render: function () {
		cursor.renderedStyles["tx"].current =
			cursor.mousepos.x - cursor.bounds.width;
		cursor.renderedStyles["ty"].current =
			cursor.mousepos.y - cursor.bounds.height;

		for (var key in cursor.renderedStyles) {
			cursor.renderedStyles[key].previous = cursor.lerp(
				cursor.renderedStyles[key].previous,
				cursor.renderedStyles[key].current,
				cursor.renderedStyles[key].amt
			);
		}

		cursor.DOM.el.style.transform =
			"translate3d(" +
			cursor.renderedStyles["tx"].previous +
			"px," +
			cursor.renderedStyles["ty"].previous +
			"px, 0) scale3d(" +
			cursor.renderedStyles["scale"].previous +
			"," +
			cursor.renderedStyles["scale"].previous +
			"," +
			cursor.renderedStyles["scale"].previous +
			")";
		cursor.DOM.el.style.opacity = cursor.renderedStyles["opacity"].previous;

		requestAnimationFrame(function () {
			cursor.render();
		});
	},
	init: function () {
		window.addEventListener("mousemove", function (e) {
			cursor.mousepos = {
				x: e.clientX,
				y: e.clientY,
			};
		});
		window.addEventListener("mousemove", cursor.onMouseMoveEv);
		utils.forEach(cursor.DOM.links, function (index, link) {
			var type = link.classList.contains("arrow-link") ? "arrow" : null;
			link.addEventListener("mouseenter", function () {
				cursor.enter(type);
			});
			link.addEventListener("mouseleave", function () {
				cursor.leave(type);
			});
		});

		var subMenuEls = document.querySelectorAll(
			"#main-header #primary-menu .sub-menu a"
		);
		utils.forEach(subMenuEls, function (index, link) {
			var img = link.querySelector("figure");
			var hoverImg = img.cloneNode(true);
			hoverImg.className = "cursor-img";
			hoverImg.querySelector("source").setAttribute("sizes", "30rem");
			hoverImg.querySelector("img").setAttribute("loading", "eager");
			link.appendChild(hoverImg);
			var bound = hoverImg.getBoundingClientRect();
			link.addEventListener("mouseover", function () {
				var activedImg = document.querySelector(
					"#main-header .cursor-img.is-active"
				);
				if (activedImg) {
					activedImg.classList.remove("is-active");
				}
				if (!hoverImg.classList.contains("is-active")) {
					hoverImg.classList.add("is-active");
				}
				if (!hoverImg.classList.contains("is-transform")) {
					window.addEventListener("mousemove", translateImg);
					hoverImg.classList.add("is-transform");
				}
			});
			link.addEventListener("mouseleave", function () {
				hoverImg.classList.remove("is-active");
				if (hoverImg.classList.contains("is-transform")) {
					window.removeEventListener("mousemove", translateImg);
					hoverImg.classList.remove("is-transform");
				}
			});

			function translateImg(e) {
				document.querySelector(
					"#main-header .cursor-img.is-active"
				).style.transform =
					"translate(" +
					(e.clientX - bound.width / 2) +
					"px, " +
					(e.clientY - bound.height / 2) +
					"px)";
			}
		});
	},
};

export default cursor;
